import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { 
  FaPhoneAlt, 
  FaEnvelope, 
  FaHome, 
  FaInfoCircle, 
  FaCoins, 
  FaServicestack, 
  FaNewspaper, 
  FaEnvelopeOpen,
  FaBars,
  FaTimes,
  FaChartLine,
  FaUserTie,
  FaBookOpen,
  FaHeadset,
  FaArrowRight
} from "react-icons/fa";
import logo from "../Utils/logo.png";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navItems = [
    { name: "Home", icon: <FaHome />, path: "/" },
    { name: "About", icon: <FaInfoCircle />, path: "/about" },
    { name: "Paisa", icon: <FaCoins />, path: "/paisa" },
    { name: "Services", icon: <FaServicestack />, path: "/services" },
    { name: "Articles", icon: <FaNewspaper />, path: "/articles" },
    { name: "Contact", icon: <FaEnvelopeOpen />, path: "/contact" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <>
      <header className={`modern-header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-inner">
          {/* Logo */}
          <a href="/" className="logo-link" onClick={closeMenu}>
            <div className="logo-box">
              <img src={logo} alt="SPi Logo" className="logo-img" />
              <div className="logo-glow"></div>
              <div className="logo-ring"></div>
            </div>
            <div className="brand-details">
              <span className="brand-main">SPi</span>
              <span className="brand-sub">Trading &amp; Investment</span>
            </div>
          </a>

          {/* Mobile Toggle */}
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          {/* Navigation */}
          <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              {navItems.map((item) => (
                <li key={item.name}>
                  <a href={item.path} className="nav-item" onClick={closeMenu}>
                    <span className="nav-icon">{item.icon}</span>
                    {item.name}
                    <span className="nav-arrow"><FaArrowRight /></span>
                  </a>
                </li>
              ))}
            </ul>

            <div className="header-contacts">
              <div className="contact-group">
                <a href="tel:+919611272633" className="contact-btn phone-btn">
                  <span className="btn-icon"><FaPhoneAlt /></span>
                  <span>+91 843 111 4189</span>
                </a>
                <a href="mailto:info@spitrading.com" className="contact-btn email-btn">
                  <span className="btn-icon"><FaEnvelope /></span>
                  <span>info@spitrading.com</span>
                </a>
              </div>
              {/* <div className="live-indicator">
                <span className="live-dot"></span>
                <span className="live-text">Live Market</span>
              </div> */}
            </div>
          </nav>
        </div>

        {/* Ticker */}
        {/* <div className="ticker-bar">
          <div className="ticker-track">
            <div className="ticker-items">
              <span className="ticker-item"><span className="ticker-up">▲</span> NIFTY 50 22,124.15 <span className="ticker-up">(+0.62%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> SENSEX 72,896.43 <span className="ticker-up">(+0.58%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> BANK NIFTY 48,234.76 <span className="ticker-up">(+0.71%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> RELIANCE 2,845.30 <span className="ticker-up">(+1.23%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-down">▼</span> TCS 3,912.45 <span className="ticker-down">(-0.34%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> INFOSYS 1,567.80 <span className="ticker-up">(+0.89%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> HDFC BANK 1,678.50 <span className="ticker-up">(+0.45%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> USD/INR 83.12 <span className="ticker-up">(+0.08%)</span></span>
            </div>
            <div className="ticker-items">
              <span className="ticker-item"><span className="ticker-up">▲</span> NIFTY 50 22,124.15 <span className="ticker-up">(+0.62%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> SENSEX 72,896.43 <span className="ticker-up">(+0.58%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> BANK NIFTY 48,234.76 <span className="ticker-up">(+0.71%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> RELIANCE 2,845.30 <span className="ticker-up">(+1.23%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-down">▼</span> TCS 3,912.45 <span className="ticker-down">(-0.34%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> INFOSYS 1,567.80 <span className="ticker-up">(+0.89%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> HDFC BANK 1,678.50 <span className="ticker-up">(+0.45%)</span></span>
              <span className="ticker-divider">|</span>
              <span className="ticker-item"><span className="ticker-up">▲</span> USD/INR 83.12 <span className="ticker-up">(+0.08%)</span></span>
            </div>
          </div>
        </div> */}
      </header>
      <div className="header-spacer"></div>
    </>
  );
};

export default Header;